module.exports = __webpack_public_path__ + "img/beruf_print.9de12cc5.jpg";